import { h } from 'preact';

export function IconMessageArrowUpRight({ width = 20, height = 20, fill = 'currentColor' }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 640 640"
      fill={fill}
      width={width}
      height={height}
      class="icon-message-arrow-up-right"
    >
      <path d="M64 192L64 416C64 469 107 512 160 512L192 512L192 584C192 597.3 202.7 608 216 608C221.2 608 226.2 606.3 230.4 603.2L345.6 516.8C349.8 513.7 354.8 512 360 512L480 512C533 512 576 469 576 416L576 192C576 139 533 96 480 96L160 96C107 96 64 139 64 192zM368 344L368 289.9L265 392.9C255.6 402.3 240.4 402.3 231.1 392.9C221.8 383.5 221.7 368.3 231.1 359L334.1 256L280 256C266.7 256 256 245.3 256 232C256 218.7 266.7 208 280 208L392 208C405.3 208 416 218.7 416 232L416 344C416 357.3 405.3 368 392 368C378.7 368 368 357.3 368 344z" />
    </svg>
  );
}